import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from './ConfirmationModal';

const RefundConfirmationModal = ({ isOpen, onClose, onConfirm, message, title = "Confirm Refund", amount, currency }) => {
  const refundIcon = (
    <div className="h-12 w-12 rounded-full bg-yellow-100 flex items-center justify-center">
      <svg className="h-6 w-6 text-yellow-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
      </svg>
    </div>
  );

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message || `Are you sure you want to process this refund? This action cannot be undone.`}
      confirmButtonText="Process Refund"
      confirmButtonClass="bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500"
      iconComponent={refundIcon}
    >
      {amount && (
        <div className="bg-yellow-50 p-3 rounded-md mt-2">
          <p className="text-center text-sm text-yellow-800">
            Refund amount: <span className="font-bold">{currency || "$"}{amount}</span>
          </p>
        </div>
      )}
    </ConfirmationModal>
  );
};

RefundConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string,
  title: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string
};

export default RefundConfirmationModal;